import { Grid } from "@mui/material";
import { SummaryItem } from "./item";

function DashboardSummary({ summaryData }) {
  return (
    <Grid container spacing={3}>
      {summaryData.map((item, index) => (
        <Grid key={index} item xs={6} md={3}>
          <SummaryItem item={item} />
        </Grid>
      ))}
    </Grid>
  );
}

export { DashboardSummary };
